var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container" }, [
    _c(
      "div",
      {
        staticClass: "contact__wrapper",
        class: { "contact__wrapper-purple": _vm.view == "purple" }
      },
      [
        _c("div", { staticClass: "contact__wrapper__bg" }, [
          _c("div", { staticClass: "contact__wrapper__component" }, [
            _c("div", { staticClass: "satisfication__wrapper" }, [
              _c(
                "div",
                {
                  staticClass:
                    "d-none d-sm-none d-md-block text-center satisfication__wrapper__elm"
                },
                [
                  _vm._m(0),
                  _c("div", { staticClass: "w-100" }, [
                    _c("h1", [
                      _vm._v(
                        _vm._s(
                          _vm._f("trans")("st_public.Your Satisfication is our")
                        )
                      )
                    ])
                  ])
                ]
              ),
              _c(
                "div",
                { staticClass: "d-inline-block d-sm-inline-block d-md-none" },
                [
                  _c("div", { staticClass: "satisfication__wrapper__elm" }, [
                    _c("h1", [
                      _vm._v(
                        _vm._s(
                          _vm._f("trans")("st_public.Your Satisfication is our")
                        )
                      )
                    ]),
                    _c("img", {
                      staticClass: "imgSmall",
                      attrs: { src: require("assets/group-26.svg") }
                    })
                  ])
                ]
              ),
              _c("p", { staticClass: "text-center" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(
                      _vm._f("trans")(
                        "st_public.Haweyya Customer Care is available"
                      )
                    ) +
                    "\n          "
                )
              ])
            ])
          ])
        ]),
        _c("div", { staticClass: "box-shadow" }, [
          _c("div", { staticClass: "row contact__wrapper__instruction" }, [
            _c("div", { staticClass: "col-md-6 text-center" }, [
              _c("h1", [
                _vm._v(
                  _vm._s(_vm._f("trans")("st_public.How do I unsubscribe"))
                )
              ]),
              _c("p", [
                _vm._v(
                  _vm._s(
                    _vm._f("trans")(
                      "st_public.You can unsubscribe anytime by clicking"
                    )
                  )
                )
              ]),
              _c(
                "a",
                {
                  staticClass: "btnWidth",
                  attrs: { href: "#" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.unsubscribe($event)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm._f("trans")("st_public.Cancel Membership")))]
              )
            ]),
            _c(
              "div",
              { staticClass: "col-md-6 text-center" },
              [
                _c("h1", [
                  _vm._v(
                    _vm._s(_vm._f("trans")("st_public.How do I get a refund"))
                  )
                ]),
                _c("p", [
                  _vm._v(
                    _vm._s(
                      _vm._f("trans")(
                        "st_public.You can easily get refund on any"
                      )
                    )
                  )
                ]),
                _c(
                  "nuxt-link",
                  {
                    staticClass: "btnWidth",
                    attrs: {
                      to: {
                        name: "lang-member-all-charges",
                        params: { lang: _vm.lang }
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm._f("trans")("st_public.Get a Refund")) +
                        "\n          "
                    )
                  ]
                )
              ],
              1
            )
          ])
        ]),
        _c("div", { staticClass: "contact__wrapper__elm" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-md-6" }, [
              _c("div", { staticClass: "contact__wrapper__info" }, [
                _c("div", { staticClass: "contact__heading" }, [
                  _c("h2", [
                    _vm._v(_vm._s(_vm._f("trans")("st_public.Ways to Connect")))
                  ])
                ]),
                _vm.geoCountryCode == "US" || _vm.geoCountryCode == "CA"
                  ? _c("ul", { staticClass: "contact__info__elm" }, [
                      _c("li", [
                        _vm._m(1),
                        _c("div", { staticClass: "contact__info__elm__text" }, [
                          _c("h3", [
                            _vm._v(
                              _vm._s(_vm._f("trans")("st_public.Speak With Us"))
                            )
                          ]),
                          _c(
                            "div",
                            {
                              staticClass: "contact__info__elm__text--duration"
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("trans")("st_public.US and Canada")
                                  ) + ":"
                                )
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm._f("trans")("st_public.5AM PT Daily")
                                  ) +
                                  "\n                  "
                              )
                            ]
                          ),
                          _c(
                            "a",
                            {
                              staticClass: "contact__info__elm__text--btn",
                              attrs: { href: "tel:" + _vm.support_phone }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm._f("trans")("st_public.Call")) + " "
                              ),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "inline-block",
                                    direction: "ltr"
                                  }
                                },
                                [_vm._v(_vm._s(_vm.support_phone))]
                              )
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "contact__info__elm__text--duration"
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("trans")("st_public.Middle East")
                                  ) + ":"
                                )
                              ]),
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm._f("trans")(
                                      "st_public.8AM- 8PM GTS  Daily"
                                    )
                                  ) +
                                  "\n                  "
                              )
                            ]
                          ),
                          _c(
                            "a",
                            {
                              staticClass: "contact__info__elm__text--btn",
                              attrs: { href: "tel:" + _vm.support_phone_me }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm._f("trans")("st_public.Call")) + " "
                              ),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "inline-block",
                                    direction: "ltr"
                                  }
                                },
                                [_vm._v(_vm._s(_vm.support_phone_me))]
                              )
                            ]
                          )
                        ])
                      ]),
                      _c("li", [
                        _vm._m(2),
                        _c("div", { staticClass: "contact__info__elm__text" }, [
                          _c("h3", [
                            _vm._v(
                              _vm._s(_vm._f("trans")("st_public.Chat with Us"))
                            )
                          ]),
                          _c(
                            "div",
                            {
                              staticClass: "contact__info__elm__text--duration"
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm._f("trans")("st_public.8AM-5PM Daily")
                                )
                              )
                            ]
                          ),
                          _vm.lang == "en"
                            ? _c(
                                "div",
                                {
                                  staticClass: "livechat_button",
                                  attrs: { "data-id": "3bf08b7bd8" }
                                },
                                [
                                  _c("a", {
                                    staticStyle: { color: "#fff" },
                                    attrs: {
                                      href:
                                        "https://www.livechatinc.com/customer-service/?utm_source=chat_button&utm_medium=referral&utm_campaign=lc_11334812"
                                    }
                                  })
                                ]
                              )
                            : _vm._e(),
                          _vm.lang == "ar"
                            ? _c(
                                "div",
                                {
                                  staticClass: "livechat_button",
                                  attrs: { "data-id": "TVGF97co5Cx" }
                                },
                                [
                                  _c("a", {
                                    staticStyle: { color: "#fff" },
                                    attrs: {
                                      href:
                                        "https://www.livechatinc.com/customer-service/?utm_source=chat_button&utm_medium=referral&utm_campaign=lc_11334812"
                                    }
                                  })
                                ]
                              )
                            : _vm._e(),
                          _c("script", { attrs: { type: "text/javascript" } }, [
                            _vm._v(
                              "\n                    window.__lc = window.__lc || {};\n                    window.__lc.license = 11334812;\n                    (function () {\n                      var lc = document.createElement('script');\n                      lc.type = 'text/javascript';\n                      lc.async = true;\n                      lc.src = ('https:' == document.location.protocol ? 'https://' : 'http://') + 'cdn.livechatinc.com/tracking.js';\n                      var s = document.getElementsByTagName('script')[0];\n                      s.parentNode.insertBefore(lc, s);\n                    })();\n                  "
                            )
                          ])
                        ])
                      ]),
                      _c("li", [
                        _vm._m(3),
                        _c("div", { staticClass: "contact__info__elm__text" }, [
                          _c("h3", [
                            _vm._v(
                              _vm._s(_vm._f("trans")("st_public.E-Mail Us"))
                            )
                          ]),
                          _c(
                            "div",
                            {
                              staticClass:
                                "contact__info__elm__text&#45;&#45;duration"
                            },
                            [
                              _vm._v(
                                _vm._s(_vm._f("trans")("st_public.Anytime"))
                              )
                            ]
                          ),
                          _c(
                            "a",
                            {
                              staticClass:
                                "contact__info__elm__text&#45;&#45;btn",
                              attrs: {
                                "data-toggle": "modal",
                                "data-target": "#email_us",
                                href: "javascript:;"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm._f("trans")("st_public.Start an Email")
                                )
                              )
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "contact__info__elm__text&#45;&#45;desc"
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm._f("trans")(
                                      "st_public.You can always send us an email directly to"
                                    )
                                  ) +
                                  ":\n                    "
                              ),
                              _c(
                                "a",
                                {
                                  attrs: { href: "mailto:" + _vm.domain_email }
                                },
                                [_vm._v(_vm._s(_vm.domain_email))]
                              )
                            ]
                          )
                        ])
                      ]),
                      _c("li", [
                        _vm._m(4),
                        _c("div", { staticClass: "contact__info__elm__text" }, [
                          _c("h3", [
                            _vm._v(
                              _vm._s(
                                _vm._f("trans")("st_public.WhatsApp Text Us")
                              )
                            )
                          ]),
                          _c(
                            "div",
                            {
                              staticClass: "contact__info__elm__text--duration"
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm._f("trans")("st_public.8AM-5PM Daily")
                                )
                              )
                            ]
                          ),
                          _c(
                            "a",
                            {
                              staticClass: "contact__info__elm__text--btn",
                              staticStyle: {
                                display: "inline-block",
                                direction: "ltr"
                              },
                              attrs: {
                                target: "_blank",
                                href: "https://wa.me/962798796173"
                              }
                            },
                            [_vm._v(_vm._s(_vm.whats_up_phone))]
                          ),
                          _c(
                            "div",
                            { staticClass: "contact__info__elm__text--desc" },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm._f("trans")(
                                      "st_public.Don’t use WhatApp? You can sent us a text massage"
                                    )
                                  ) +
                                  ":\n                    "
                              ),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "inline-block",
                                    direction: "ltr"
                                  }
                                },
                                [_vm._v(_vm._s(_vm.whats_up_phone))]
                              )
                            ]
                          )
                        ])
                      ])
                    ])
                  : _c("ul", { staticClass: "contact__info__elm" }, [
                      _c("li", [
                        _vm._m(5),
                        _c("div", { staticClass: "contact__info__elm__text" }, [
                          _c("h3", [
                            _vm._v(
                              _vm._s(
                                _vm._f("trans")("st_public.WhatsApp Text Us")
                              )
                            )
                          ]),
                          _c(
                            "div",
                            {
                              staticClass: "contact__info__elm__text--duration"
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm._f("trans")("st_public.8AM-5PM Daily")
                                )
                              )
                            ]
                          ),
                          _c(
                            "a",
                            {
                              staticClass: "contact__info__elm__text--btn",
                              staticStyle: {
                                display: "inline-block",
                                direction: "ltr"
                              },
                              attrs: {
                                target: "_blank",
                                href: "https://wa.me/962798796173"
                              }
                            },
                            [_vm._v(_vm._s(_vm.whats_up_phone))]
                          ),
                          _c(
                            "div",
                            { staticClass: "contact__info__elm__text--desc" },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm._f("trans")(
                                      "st_public.Don’t use WhatApp? You can sent us a text massage"
                                    )
                                  ) +
                                  ":\n                    "
                              ),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "inline-block",
                                    direction: "ltr"
                                  }
                                },
                                [_vm._v(_vm._s(_vm.whats_up_phone))]
                              )
                            ]
                          )
                        ])
                      ]),
                      _c("li", [
                        _vm._m(6),
                        _c("div", { staticClass: "contact__info__elm__text" }, [
                          _c("h3", [
                            _vm._v(
                              _vm._s(_vm._f("trans")("st_public.Speak With Us"))
                            )
                          ]),
                          _c(
                            "div",
                            {
                              staticClass: "contact__info__elm__text--duration"
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("trans")("st_public.US and Canada")
                                  ) + ":"
                                )
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm._f("trans")("st_public.5AM PT Daily")
                                  ) +
                                  "\n                  "
                              )
                            ]
                          ),
                          _c(
                            "a",
                            {
                              staticClass: "contact__info__elm__text--btn",
                              attrs: { href: "tel:" + _vm.support_phone }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm._f("trans")("st_public.Call")) + " "
                              ),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "inline-block",
                                    direction: "ltr"
                                  }
                                },
                                [_vm._v(_vm._s(_vm.support_phone))]
                              )
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "contact__info__elm__text--duration"
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("trans")("st_public.Middle East")
                                  ) + ":"
                                )
                              ]),
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm._f("trans")(
                                      "st_public.8AM- 8PM GTS  Daily"
                                    )
                                  ) +
                                  "\n                  "
                              )
                            ]
                          ),
                          _c(
                            "a",
                            {
                              staticClass: "contact__info__elm__text--btn",
                              attrs: { href: "tel:" + _vm.support_phone_me }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm._f("trans")("st_public.Call")) + " "
                              ),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "inline-block",
                                    direction: "ltr"
                                  }
                                },
                                [_vm._v(_vm._s(_vm.support_phone_me))]
                              )
                            ]
                          )
                        ])
                      ]),
                      _c("li", [
                        _vm._m(7),
                        _c("div", { staticClass: "contact__info__elm__text" }, [
                          _c("h3", [
                            _vm._v(
                              _vm._s(_vm._f("trans")("st_public.E-Mail Us"))
                            )
                          ]),
                          _c(
                            "div",
                            {
                              staticClass:
                                "contact__info__elm__text&#45;&#45;duration"
                            },
                            [
                              _vm._v(
                                _vm._s(_vm._f("trans")("st_public.Anytime"))
                              )
                            ]
                          ),
                          _c(
                            "a",
                            {
                              staticClass:
                                "contact__info__elm__text&#45;&#45;btn",
                              attrs: {
                                "data-toggle": "modal",
                                "data-target": "#email_us",
                                href: "javascript:;"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm._f("trans")("st_public.Start an Email")
                                )
                              )
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "contact__info__elm__text&#45;&#45;desc"
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm._f("trans")(
                                      "st_public.You can always send us an email directly to"
                                    )
                                  ) +
                                  ":\n                    "
                              ),
                              _c(
                                "a",
                                {
                                  attrs: { href: "mailto:" + _vm.domain_email }
                                },
                                [_vm._v(_vm._s(_vm.domain_email))]
                              )
                            ]
                          )
                        ])
                      ]),
                      _c("li", [
                        _vm._m(8),
                        _c("div", { staticClass: "contact__info__elm__text" }, [
                          _c("h3", [
                            _vm._v(
                              _vm._s(_vm._f("trans")("st_public.Chat with Us"))
                            )
                          ]),
                          _c(
                            "div",
                            {
                              staticClass: "contact__info__elm__text--duration"
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm._f("trans")("st_public.8AM-5PM Daily")
                                )
                              )
                            ]
                          ),
                          _vm.lang == "en"
                            ? _c(
                                "div",
                                {
                                  staticClass: "livechat_button",
                                  attrs: { "data-id": "3bf08b7bd8" }
                                },
                                [
                                  _c("a", {
                                    staticStyle: { color: "#fff" },
                                    attrs: {
                                      href:
                                        "https://www.livechatinc.com/customer-service/?utm_source=chat_button&utm_medium=referral&utm_campaign=lc_11334812"
                                    }
                                  })
                                ]
                              )
                            : _vm._e(),
                          _vm.lang == "ar"
                            ? _c(
                                "div",
                                {
                                  staticClass: "livechat_button",
                                  attrs: { "data-id": "TVGF97co5Cx" }
                                },
                                [
                                  _c("a", {
                                    staticStyle: { color: "#fff" },
                                    attrs: {
                                      href:
                                        "https://www.livechatinc.com/customer-service/?utm_source=chat_button&utm_medium=referral&utm_campaign=lc_11334812"
                                    }
                                  })
                                ]
                              )
                            : _vm._e(),
                          _c("script", { attrs: { type: "text/javascript" } }, [
                            _vm._v(
                              "\n                    window.__lc = window.__lc || {};\n                    window.__lc.license = 11334812;\n                    (function () {\n                      var lc = document.createElement('script');\n                      lc.type = 'text/javascript';\n                      lc.async = true;\n                      lc.src = ('https:' == document.location.protocol ? 'https://' : 'http://') + 'cdn.livechatinc.com/tracking.js';\n                      var s = document.getElementsByTagName('script')[0];\n                      s.parentNode.insertBefore(lc, s);\n                    })();\n                  "
                            )
                          ])
                        ])
                      ])
                    ])
              ])
            ]),
            _c("div", { staticClass: "col-md-6" }, [
              _c("div", { staticClass: "contact__heading" }, [
                _c("h2", [
                  _vm._v(
                    _vm._s(
                      _vm._f("trans")("st_public.Frequently Asked Questions")
                    )
                  )
                ])
              ]),
              _c(
                "ul",
                { staticClass: "contact__info__elm contact__info__elm--faq" },
                [
                  _c("li", [
                    _c("h1", [
                      _vm._v(
                        _vm._s(_vm._f("trans")("st_public.What is Haweyya?"))
                      )
                    ]),
                    _c("div", { staticClass: "paragraph" }, [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm._f("trans")(
                              "st_public.Haweyya is a people search service that organizes"
                            )
                          ) +
                          "\n\n                " +
                          _vm._s(
                            _vm._f("trans")(
                              "st_public.Haweyya enables you to search for anyone by name"
                            )
                          ) +
                          "\n              "
                      )
                    ])
                  ]),
                  _c("li", [
                    _c("h1", [
                      _vm._v(
                        _vm._s(
                          _vm._f("trans")("st_public.How do I perform a search")
                        )
                      )
                    ]),
                    _c("div", { staticClass: "paragraph" }, [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm._f("trans")(
                              "st_public.Haweyya supports five types of searches"
                            )
                          ) +
                          "\n              "
                      )
                    ])
                  ]),
                  _c("li", [
                    _c("h1", [
                      _vm._v(
                        _vm._s(
                          _vm.$root.trans("st_public.Three Section Question")
                        )
                      )
                    ]),
                    _c("div", {
                      staticClass: "paragraph",
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.$root.trans(
                            "st_public.Three Section Question Answer",
                            {
                              domaindetails: _vm.$root.trans(
                                "st_public." + _vm.domain + "_details"
                              )
                            }
                          )
                        )
                      }
                    })
                  ])
                ]
              )
            ])
          ])
        ])
      ]
    ),
    _c(
      "div",
      {
        staticClass: "modal fade",
        attrs: {
          id: "email_us",
          tabindex: "-1",
          role: "dialog",
          "aria-labelledby": "exampleModalLabel",
          "aria-hidden": "true"
        }
      },
      [
        _c(
          "div",
          { staticClass: "modal-dialog modal-lg", attrs: { role: "document" } },
          [
            _c("div", { staticClass: "modal-content" }, [
              _c("div", { staticClass: "modal-header" }, [
                _c(
                  "h5",
                  {
                    staticClass: "modal-title",
                    attrs: { id: "exampleModalLabel" }
                  },
                  [
                    _vm._v(
                      _vm._s(_vm._f("trans")("st_public.Email Customer Care"))
                    )
                  ]
                ),
                _vm._m(9)
              ]),
              _c("div", { staticClass: "modal-body" }, [
                _c("div", {
                  staticClass: "subtitle",
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$root.trans("st_public.Leave us a detailed message", {
                        domain: _vm.domain
                      })
                    )
                  }
                }),
                _c("div", { staticClass: "form_content" }, [
                  _c(
                    "form",
                    {
                      attrs: { id: "email_customer_care_form" },
                      on: {
                        submit: function($event) {
                          $event.preventDefault()
                          return _vm.contactus($event)
                        }
                      }
                    },
                    [
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", { attrs: { for: "reason" } }, [
                          _vm._v(
                            _vm._s(
                              _vm.$root.trans(
                                "st_public.Reason for Contacting Haweyya",
                                {
                                  domain:
                                    _vm.domain.charAt(0).toUpperCase() +
                                    _vm.domain.slice(1)
                                }
                              )
                            )
                          )
                        ]),
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.reason,
                                expression: "reason"
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: { name: "reason", id: "reason" },
                            on: {
                              change: function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.reason = $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              }
                            }
                          },
                          [
                            _c("option", { attrs: { value: "" } }, [
                              _vm._v(
                                _vm._s(
                                  _vm._f("trans")("st_public.Select a Topic")
                                )
                              )
                            ]),
                            _c("option", { attrs: { value: "general" } }, [
                              _vm._v(
                                _vm._s(
                                  _vm._f("trans")("st_public.General Question")
                                )
                              )
                            ]),
                            _c("option", { attrs: { value: "privacy" } }, [
                              _vm._v(
                                _vm._s(_vm._f("trans")("st_public.Privacy"))
                              )
                            ]),
                            _c("option", { attrs: { value: "billing" } }, [
                              _vm._v(
                                _vm._s(
                                  _vm._f("trans")("st_public.Speak Billing")
                                )
                              )
                            ]),
                            _c("option", { attrs: { value: "technical" } }, [
                              _vm._v(
                                _vm._s(_vm._f("trans")("st_public.Technical"))
                              )
                            ]),
                            _c("option", { attrs: { value: "mobile" } }, [
                              _vm._v(
                                _vm._s(_vm._f("trans")("st_public.Mobile App"))
                              )
                            ]),
                            _c("option", { attrs: { value: "press" } }, [
                              _vm._v(
                                _vm._s(
                                  _vm._f("trans")("st_public.Press Inquiry")
                                )
                              )
                            ]),
                            _c("option", { attrs: { value: "bizdev" } }, [
                              _vm._v(
                                _vm._s(
                                  _vm._f("trans")(
                                    "st_public.Business Development"
                                  )
                                )
                              )
                            ]),
                            _c("option", { attrs: { value: "partner" } }, [
                              _vm._v(
                                _vm._s(
                                  _vm._f("trans")("st_public.Become a Partner")
                                )
                              )
                            ])
                          ]
                        ),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.errors.has("reason"),
                                expression: "errors.has('reason')"
                              }
                            ],
                            staticClass: "invalid-feedback"
                          },
                          [
                            _vm._v(
                              "\n                  " +
                                _vm._s(
                                  _vm._f("trans")(
                                    "st_public." + _vm.errors.first("reason")
                                  )
                                ) +
                                "\n                "
                            )
                          ]
                        )
                      ]),
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", { attrs: { for: "name" } }, [
                          _vm._v(
                            _vm._s(
                              _vm._f("trans")(
                                "st_public.Your First and Last Name"
                              )
                            )
                          )
                        ]),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.name,
                              expression: "name"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: { id: "name", name: "name", type: "text" },
                          domProps: { value: _vm.name },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.name = $event.target.value
                            }
                          }
                        }),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.errors.has("name"),
                                expression: "errors.has('name')"
                              }
                            ],
                            staticClass: "invalid-feedback"
                          },
                          [
                            _vm._v(
                              "\n                  " +
                                _vm._s(
                                  _vm._f("trans")(
                                    "st_public." + _vm.errors.first("name")
                                  )
                                ) +
                                "\n                "
                            )
                          ]
                        )
                      ]),
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", { attrs: { for: "email" } }, [
                          _vm._v(_vm._s(_vm._f("trans")("st_public.email")))
                        ]),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.email,
                              expression: "email"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required|email",
                              expression: "'required|email'"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: { id: "email", name: "email", type: "email" },
                          domProps: { value: _vm.email },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.email = $event.target.value
                            }
                          }
                        }),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.errors.has("email"),
                                expression: "errors.has('email')"
                              }
                            ],
                            staticClass: "invalid-feedback"
                          },
                          [
                            _vm._v(
                              "\n                  " +
                                _vm._s(
                                  _vm._f("trans")(
                                    "st_public." + _vm.errors.first("email")
                                  )
                                ) +
                                "\n                "
                            )
                          ]
                        )
                      ]),
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", { attrs: { for: "phone" } }, [
                          _vm._v(
                            _vm._s(
                              _vm._f("trans")("st_public.Speak With An Agent")
                            ) +
                              "\n                  (" +
                              _vm._s(_vm._f("trans")("st_public.optional")) +
                              ")"
                          )
                        ]),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.phone,
                              expression: "phone"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: {
                            id: "phone",
                            name: "phone",
                            telephone: "rule",
                            type: "tel"
                          },
                          domProps: { value: _vm.phone },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.phone = $event.target.value
                            }
                          }
                        })
                      ]),
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", { attrs: { for: "user_feedback" } }, [
                          _vm._v(
                            _vm._s(
                              _vm._f("trans")("st_public.details_description")
                            )
                          )
                        ]),
                        _c("textarea", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.details_description,
                              expression: "details_description"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: {
                            rows: "7",
                            id: "details_description",
                            name: "details_description"
                          },
                          domProps: { value: _vm.details_description },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.details_description = $event.target.value
                            }
                          }
                        }),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.errors.has("details_description"),
                                expression: "errors.has('details_description')"
                              }
                            ],
                            staticClass: "invalid-feedback"
                          },
                          [
                            _vm._v(
                              "\n                  " +
                                _vm._s(
                                  _vm._f("trans")(
                                    "st_public." +
                                      _vm.errors.first("details_description")
                                  )
                                ) +
                                "\n                "
                            )
                          ]
                        )
                      ]),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-lg btn-success btn-block",
                          attrs: {
                            id: "submit_email_form_button",
                            type: "submit"
                          }
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm._f("trans")("st_public.Submit")) +
                              "\n              "
                          )
                        ]
                      )
                    ]
                  )
                ])
              ])
            ])
          ]
        ),
        _vm._m(10)
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", {}, [
      _c("img", {
        staticClass: "mb-3",
        attrs: { src: require("assets/group-26.svg") }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("figure", [
      _c("img", { attrs: { src: require("assets/phoneIcon.svg") } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("figure", [
      _c("img", { attrs: { src: require("assets/chat.svg") } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("figure", [
      _c("img", { attrs: { src: require("assets/mail.svg") } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("figure", [
      _c("img", { attrs: { src: require("assets/whatsapp.svg") } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("figure", [
      _c("img", { attrs: { src: require("assets/whatsapp.svg") } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("figure", [
      _c("img", { attrs: { src: require("assets/phoneIcon.svg") } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("figure", [
      _c("img", { attrs: { src: require("assets/mail.svg") } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("figure", [
      _c("img", { attrs: { src: require("assets/chat.svg") } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "close",
        attrs: {
          type: "button",
          "data-dismiss": "modal",
          "aria-label": "Close"
        }
      },
      [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "chat-widget-container" }, [
      _c("style", [
        _vm._v(
          "\n        #chat-widget-container {\n          display: block !important;\n        }\n\n        .livechat_button a {\n          color: #fff !important;\n        }\n      "
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7d788c35", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d788c35","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/_lang/contact.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-7d788c35","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/_lang/contact.vue
// module chunks = 13